module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_19_3.190cd38f.jpeg";